<template>
  <base-material-card
    :icon="icon"
    class="v-card--material-stats"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:after-heading>
      <div class="ml-auto text-right">
        <div class="grey--text font-weight title-text" v-text="title" />
      </div>
    </template>

    <v-container>
      <div class="header-section">
        <v-icon size="24" class="ml-1 mr-2">mdi-cash</v-icon>
        <span>Informações de NF</span>
      </div>

      <v-divider class="section-divider" />

      <!-- Seção de pagamentos -->
      <div class="info-row">
        <span
          v-if="subTextAdd !== undefined"
          class="info-label"
          :class="subTextColor"
          v-text="subTextAdd"
        />
        <span
          v-if="subTextAddV !== undefined"
          class="info-value"
          :class="subTextColor"
          v-text="subTextAddV"
        />
      </div>

      <div class="info-row">
        <span
          v-if="subTextAdd1 !== undefined"
          class="info-label"
          :class="subTextColor"
          v-text="subTextAdd1"
        />
        <span
          v-if="subTextAdd1V !== undefined"
          class="info-value"
          :class="subTextColor"
          v-text="subTextAdd1V"
        />
      </div>

      <div class="info-row with-spacing">
        <span
          v-if="subTextAdd2 !== undefined"
          class="info-label"
          :class="subTextColor"
          v-text="subTextAdd2"
        />
        <span
          v-if="subTextAdd2V !== undefined"
          class="info-value"
          :class="subTextColor"
          v-text="subTextAdd2V"
        />
      </div>

      <div class="info-row with-spacing">
        <span
          v-if="subTextAdd3 !== undefined"
          class="info-label tall"
          :class="subTextColor"
          v-text="subTextAdd3"
        />
        <span
          v-if="subTextAdd3V !== undefined"
          class="info-value"
          :class="subTextColor"
          v-text="subTextAdd3V"
        />
      </div>

      <div class="info-row">
        <span
          v-if="subTextAdd4 !== undefined"
          class="info-label with-top-margin"
          :class="subTextColor"
          v-text="subTextAdd4"
        />
        <span
          v-if="subTextAdd4V !== undefined"
          class="info-value"
          :class="subTextColor"
          v-text="subTextAdd4V"
        />
      </div>

      <!-- Detailed information section -->
      <template v-if="detalhado && detalhado.length > 0">
        <v-divider class="details-divider" />

        <!-- Pagamento (empresa associada paga ao parametro) -->
        <div class="detail-row">
          <span class="detail-label"
            >- Paga ao {{ formatarEmpresa(parametro) }}:
          </span>
          <span class="detail-value" v-if="getPagamentoDetalhe()">
            {{ getPagamentoDetalhe().quantidade }}
            {{ replaceTipo(getPagamentoDetalhe().tipo) }}
          </span>
          <span class="detail-value" v-else>-</span>
        </div>

        <!-- Recebimento (empresa associada recebe do parametro) -->
        <div class="detail-row">
          <span class="detail-label"
            >- Recebe do {{ formatarEmpresa(parametro) }}:
          </span>
          <span class="detail-value" v-if="getRecebimentoDetalhe()">
            {{ getRecebimentoDetalhe().quantidade }}
            {{ replaceTipo(getRecebimentoDetalhe().tipo) }}
          </span>
          <span class="detail-value" v-else>-</span>
        </div>
      </template>
    </v-container>
  </base-material-card>
</template>

<script>
import Card from "./Card";
import { ContentLoader } from "vue-content-loader";

export default {
  name: "MaterialStatsCardNF",
  components: { ContentLoader },
  inheritAttrs: false,
  data() {
    return {
      panel: [1], // Deixa o primeiro painel aberto
    };
  },

  props: {
    ...Card.props,
    downloadFunction: Function,
    icon: {
      type: String,
      required: true,
    },
    subIcon: {
      type: String,
      default: undefined,
    },
    subIconColor: {
      type: String,
      default: undefined,
    },
    subIconE: {
      type: String,
      default: undefined,
    },
    subIconColorE: {
      type: String,
      default: undefined,
    },
    subTextColor: {
      type: String,
      default: undefined,
    },
    subText: {
      type: String,
      default: undefined,
    },
    subTextE: {
      type: String,
      default: undefined,
    },

    subTextColorE: {
      type: String,
      default: undefined,
    },

    subTextAdd: {
      type: String,
      default: "",
    },
    subTextAdd1: {
      type: String,
      default: "",
    },
    subTextAdd2: {
      type: String,
      default: "",
    },
    subTextAdd3: {
      type: String,
      default: "",
    },
    subTextAdd4: {
      type: String,
      default: "",
    },
    subTextAdd5: {
      type: String,
      default: "",
    },
    subTextAdd6: {
      type: String,
      default: "",
    },
    subTextAdd7: {
      type: String,
      default: "",
    },
    subTextAdd8: {
      type: String,
      default: "",
    },

    subTextAdd9: {
      type: String,
      default: "",
    },

    subTextAdd10: {
      type: String,
      default: "",
    },

    subTextAdd11: {
      type: String,
      default: "",
    },

    subTextAdd12: {
      type: String,
      default: "",
    },

    subTextAdd13: {
      type: String,
      default: "",
    },

    subTextAddV: {
      type: String,
      default: "0",
    },
    subTextAdd1V: {
      type: String,
      default: "0",
    },
    subTextAdd2V: {
      type: String,
      default: "0",
    },
    subTextAdd3V: {
      type: String,
      default: "0",
    },
    subTextAdd4V: {
      type: String,
      default: undefined,
    },
    subTextAdd5V: {
      type: String,
      default: undefined,
    },
    subTextAdd6V: {
      type: String,
      default: undefined,
    },
    subTextAdd7V: {
      type: String,
      default: undefined,
    },

    subTextAdd8V: {
      type: String,
      default: undefined,
    },

    subTextAdd9V: {
      type: String,
      default: undefined,
    },

    subTextAdd10V: {
      type: String,
      default: undefined,
    },

    subTextAdd11V: {
      type: String,
      default: undefined,
    },

    subTextAdd12V: {
      type: String,
      default: undefined,
    },

    subTextAdd13V: {
      type: String,
      default: undefined,
    },

    subTextAdd2E: {
      type: String,
      default: undefined,
    },

    btn_download: {
      type: String,
      default: undefined,
    },

    subTextAdd3E: {
      type: String,
      default: undefined,
    },
    subTextAdd4E: {
      type: String,
      default: undefined,
    },

    title: {
      type: String,
      default: undefined,
    },
    value: {
      type: String,
      default: undefined,
    },
    valuex: {
      type: Boolean,
      default: undefined,
    },

    smallValue: {
      type: String,
      default: undefined,
    },
    detalhado: {
      type: Array,
      default: () => [],
    },
    empresaAssociada: {
      type: String,
      default: "",
    },
    parametro: {
      type: String,
      default: "",
    },
  },

  methods: {
    calculateHeight() {
      // Suponha que você queira 30% da altura do elemento pai
      const parentHeight = 120; // Substitua isso pela altura real do elemento pai
      const percentage = 30;
      return (parentHeight * percentage) / 100;
    },
    formatarEmpresa(empresa) {
      switch (empresa.toUpperCase()) {
        case "MEMORIAL PARQUE MACEIÓ":
        case "MEMORIAL PARQUE MACEIO":
          return "Memorial";
        case "PREVIDA":
          return "Previda";
        case "PARQUE DO AGRESTE":
          return "AM";
        case "PARQUE DAS FLORES":
          return "Parque";
        case "CEMITERIO PREVIDA":
          return "Versan";
        default:
          return empresa; // Retorna o nome original se não houver correspondência
      }
    },
    getPagamentoDetalhe() {
      // Encontra o detalhe onde a empresa associada paga ao parametro
      if (!this.detalhado || this.detalhado.length === 0) return null;
      return this.detalhado.find(
        (d) =>
          d.pagador === this.empresaAssociada && d.recebedor === this.parametro
      );
    },
    getRecebimentoDetalhe() {
      // Encontra o detalhe onde a empresa associada recebe do parametro
      if (!this.detalhado || this.detalhado.length === 0) return null;
      return this.detalhado.find(
        (d) =>
          d.recebedor === this.empresaAssociada && d.pagador === this.parametro
      );
    },
    replaceTipo(tipo) {
      if (!tipo) return "";

      return tipo
        .replace(
          /Serviços Administrativos e Cemiteriais/i,
          "Serviços Cemiteriais"
        )
        .replace(/Planos/i, "Serviços Funerários");
    },
  },
};
</script>

<style scoped>
.no-elevation {
  box-shadow: none !important;
}

.title-text {
  font-size: 12px;
  font-weight: bold;
}

.header-section {
  margin-bottom: 8px;
}

.section-divider {
  margin-bottom: 8px;
}

.details-divider {
  margin: 12px 0;
}

.info-row {
  margin-bottom: 4px;
}

.info-row.with-spacing {
  margin-top: 20px;
}

.info-label {
  font-size: 14px;
  font-weight: normal;
}

.info-label.tall {
  height: 100px;
}

.info-label.with-top-margin {
  margin-top: 204px;
}

.info-value {
  font-size: 14px;
  font-weight: bold;
}

.detail-row {
  margin-bottom: 6px;
}

.detail-label {
  font-size: 14px;
}

.detail-value {
  font-size: 14px;
  font-weight: bold;
}
</style>

<style lang="sass">
.v-card--material-stats
  display: flex
  flex-wrap: wrap
  position: relative

  > div:first-child
    justify-content: space-between

  .v-card
    border-radius: 4px
    flex: 0 1 auto

  .v-card__text
    display: inline-block
    flex: 1 0 calc(100% - 120px)
    position: absolute
    top: 0
    right: 0
    width: 100%

    .custom-sub-text
      font-size: 12px


  .v-card__actions
    flex: 1 0 100%
</style>
